/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdminUserAccount } from '../models/AdminUserAccount';
import type { AgentUser } from '../models/AgentUser';
import type { ArtistUser } from '../models/ArtistUser';
import type { BarUser } from '../models/BarUser';
import type { BreweryUser } from '../models/BreweryUser';
import type { CorporateEventUser } from '../models/CorporateEventUser';
import type { CountryclubUser } from '../models/CountryclubUser';
import type { CurrentUser } from '../models/CurrentUser';
import type { GreekUser } from '../models/GreekUser';
import type { Image } from '../models/Image';
import type { ManagerUser } from '../models/ManagerUser';
import type { MunicipalUser } from '../models/MunicipalUser';
import type { NightclubUser } from '../models/NightclubUser';
import type { OtherSellerUser } from '../models/OtherSellerUser';
import type { RestaurantUser } from '../models/RestaurantUser';
import type { UPBUser } from '../models/UPBUser';
import type { UserExists } from '../models/UserExists';
import type { WeddingUser } from '../models/WeddingUser';
import { request as __request } from '../core/request';

export class AuthService {

    /**
     * Get Current User
     * @result CurrentUser Successful Response
     * @throws ApiError
     */
    public static async getCurrentUser(): Promise<CurrentUser> {
        const result = await __request({
            method: 'GET',
            path: `/auth/get_current_user`,
        });
        return result.body;
    }

    /**
     * Get User
     * @result AdminUserAccount | AgentUser | ArtistUser | BarUser | BreweryUser | CorporateEventUser | CountryclubUser | GreekUser | ManagerUser | MunicipalUser | NightclubUser | OtherSellerUser | RestaurantUser | UPBUser | UserExists | WeddingUser Successful Response
     * @throws ApiError
     */
    public static async getUser(): Promise<AdminUserAccount | AgentUser | ArtistUser | BarUser | BreweryUser | CorporateEventUser | CountryclubUser | GreekUser | ManagerUser | MunicipalUser | NightclubUser | OtherSellerUser | RestaurantUser | UPBUser | UserExists | WeddingUser> {
        const result = await __request({
            method: 'GET',
            path: `/auth/get_user`,
        });
        return result.body;
    }

    /**
     * Create User
     * @param requestBody
     * @param signInMessage
     * @result AdminUserAccount | AgentUser | ArtistUser | BarUser | BreweryUser | CorporateEventUser | CountryclubUser | GreekUser | ManagerUser | MunicipalUser | NightclubUser | OtherSellerUser | RestaurantUser | UPBUser | WeddingUser Successful Response
     * @throws ApiError
     */
    public static async createUser({
        requestBody,
        signInMessage,
    }: {
        requestBody: AdminUserAccount | AgentUser | ArtistUser | BarUser | BreweryUser | CorporateEventUser | CountryclubUser | GreekUser | ManagerUser | MunicipalUser | NightclubUser | OtherSellerUser | RestaurantUser | UPBUser | WeddingUser,
        signInMessage?: string,
    }
): Promise<AdminUserAccount | AgentUser | ArtistUser | BarUser | BreweryUser | CorporateEventUser | CountryclubUser | GreekUser | ManagerUser | MunicipalUser | NightclubUser | OtherSellerUser | RestaurantUser | UPBUser | WeddingUser> {
    const result = await __request({
        method: 'POST',
        path: `/auth/create_user`,
        query: {
            'sign_in_message': signInMessage,
        },
        body: requestBody,
        errors: {
            422: `Validation Error`,
        },
    });
    return result.body;
}

/**
 * Update User Profile Image
 * @param requestBody
 * @result AdminUserAccount | AgentUser | ArtistUser | BarUser | BreweryUser | CorporateEventUser | CountryclubUser | GreekUser | ManagerUser | MunicipalUser | NightclubUser | OtherSellerUser | RestaurantUser | UPBUser | WeddingUser Successful Response
 * @throws ApiError
 */
public static async updateUserProfileImage({
    requestBody,
}: {
    requestBody: Image,
}
): Promise<AdminUserAccount | AgentUser | ArtistUser | BarUser | BreweryUser | CorporateEventUser | CountryclubUser | GreekUser | ManagerUser | MunicipalUser | NightclubUser | OtherSellerUser | RestaurantUser | UPBUser | WeddingUser> {
    const result = await __request({
        method: 'PATCH',
        path: `/auth/update_user_profile_image`,
        body: requestBody,
        errors: {
            422: `Validation Error`,
        },
    });
    return result.body;
}

/**
 * User Login
 * @result any Successful Response
 * @throws ApiError
 */
public static async userLogin(): Promise<any> {
    const result = await __request({
        method: 'POST',
        path: `/auth/user_login`,
    });
    return result.body;
}

}